import { useGlotaT } from '../../../../../../hooks/useGlotaTranslation';

export const useVariablesList = () => {
  const contactNameDesc = useGlotaT('spa.messageBuilder.variables.descriptions.contactName');
  const contactFirstNameDesc = useGlotaT('spa.messageBuilder.variables.descriptions.contactFirstName');
  const contactPhoneDesc = useGlotaT('spa.messageBuilder.variables.descriptions.contactPhone');
  const contactEmailDesc = useGlotaT('spa.messageBuilder.variables.descriptions.contactEmail');
  const operatorNameDesc = useGlotaT('spa.messageBuilder.variables.descriptions.operatorName');
  const departmentNameDesc = useGlotaT('spa.messageBuilder.variables.descriptions.departmentName');
  const dateCurrentDesc = useGlotaT('spa.messageBuilder.variables.descriptions.dateCurrent');
  const timeCurrentDesc = useGlotaT('spa.messageBuilder.variables.descriptions.timeCurrent');
  const protocolNumberDesc = useGlotaT('spa.messageBuilder.variables.descriptions.protocolNumber');

  return [
    {
      id: 1,
      label: '[contact_name]',
      description: contactNameDesc,
    },
    {
      id: 2,
      label: '[contact_first_name]',
      description: contactFirstNameDesc,
    },
    {
      id: 3,
      label: '[contact_phone]',
      description: contactPhoneDesc,
    },
    {
      id: 4,
      label: '[contact_email]',
      description: contactEmailDesc,
    },
    {
      id: 5,
      label: '[operator_name]',
      description: operatorNameDesc,
    },
    {
      id: 6,
      label: '[department_name]',
      description: departmentNameDesc,
    },
    { id: 7, label: '[date_current]', description: dateCurrentDesc },
    { id: 8, label: '[time_current]', description: timeCurrentDesc },
    {
      id: 9,
      label: '[protocol_number]',
      description: protocolNumberDesc,
    },
  ];
};

// Mantém exportação padrão para compatibilidade (será traduzida dinamicamente)
const VariablesList = [
  {
    id: 1,
    label: '[contact_name]',
    description: 'Para inserir o nome completo do contato',
  },
  {
    id: 2,
    label: '[contact_first_name]',
    description: 'Para inserir o primeiro nome do contato',
  },
  {
    id: 3,
    label: '[contact_phone]',
    description: 'Para inserir o número do telefone do contato',
  },
  {
    id: 4,
    label: '[contact_email]',
    description: 'Para inserir o email do contato',
  },
  {
    id: 5,
    label: '[operator_name]',
    description: 'Para inserir o nome do atendente do contato',
  },
  {
    id: 6,
    label: '[department_name]',
    description: 'Para inserir o nome do departamento',
  },
  { id: 7, label: '[date_current]', description: 'Para inserir a data' },
  { id: 8, label: '[time_current]', description: 'Para inserir o horário' },
  {
    id: 9,
    label: '[protocol_number]',
    description: 'Para inserir o protocolo de atendimento',
  },
];

export default VariablesList;
